import { deviceWidth } from './deviceWidth';

/**
 * calculate padding top value for different header types
 * @param {*} headerComp array
 * @return {number} padding top value
 */
export const getPaddingTopValue = (headerComp) => {
  const headerArr = ['header10'];

  const headerType = headerComp?.findIndex((layout) => {
    if (headerArr.includes(layout.name.toLowerCase())) return true;
    else return false;
  });
  if (headerType > -1) {
    return deviceWidth <= 767 ? 141 : 151.38;
  } else {
    return deviceWidth <= 767 ? 60 : 75;
  }
};
